module.exports = __webpack_public_path__ + "img/album04_03.e15cfb19.jpg";